export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-zoom/src/constant.js
// module id = 1627
// module chunks = 0